import { put, takeLatest, all, take } from 'redux-saga/effects'

import { rawContentActions } from '@tabeeb/shared/content'

import * as actions from '../actions'
import * as notificationActions from '../../notification/actions'

function* onPreprocessAddClassificationAnnotations({ payload }) {
  yield put(
    actions.getAiAnnotations.request({
      ContentId: payload.ContentId,
      PageIds: payload.Annotations.map((a) => a.PageId),
    })
  )
  const checkResult = yield take([actions.getAiAnnotations.success, actions.getAiAnnotations.failed])

  if (checkResult.type !== actions.getAiAnnotations.success().type) {
    yield put(actions.addClassificationAnnotations.failed())
    return
  }

  const existingAIAnnotations = checkResult.response?.data ?? []
  if (existingAIAnnotations.length === 0) {
    yield put(actions.addClassificationAnnotations.request(payload))
    return
  }

  const model = {
    AnnotationIds: existingAIAnnotations.map((a) => a.AnnotationId),
    AIObjectIds: payload.Annotations.map((a) => a.AIObjectId),
  }
  yield put(actions.getAnnotationAiObjects.request(model))

  const resultAction = yield take([actions.getAnnotationAiObjects.success, actions.getAnnotationAiObjects.failed])

  if (resultAction.type !== actions.getAnnotationAiObjects.success().type) {
    yield put(actions.addClassificationAnnotations.failed())
    return
  }

  const annotationAIObjects = resultAction.response?.data ?? []
  if (annotationAIObjects.length === 0) {
    yield put(actions.addClassificationAnnotations.request(payload))
    return
  }

  const mergeByAnnotationId = (a, b) => {
    const map = new Map()

    const combinedArrays = [...a, ...b]

    for (const element of combinedArrays) {
      if (map.has(element.AnnotationId)) {
        map.set(element.AnnotationId, { ...map.get(element.AnnotationId), ...element })
      } else {
        map.set(element.AnnotationId, { ...element })
      }
    }

    return Array.from(map.values())
  }

  const mergedByAnnotationId = mergeByAnnotationId(existingAIAnnotations, annotationAIObjects)
  const filteredAnnotations = payload.Annotations.filter(
    (annotation) =>
      !mergedByAnnotationId.some((ma) => ma.AIObjectId === annotation.AIObjectId && ma.PageId === annotation.PageId)
  )

  if (filteredAnnotations.length === 0) {
    yield put(
      notificationActions.onAddWarningNotification({
        message: 'These pages are already labeled with the selected CV class(es).',
      })
    )
    return
  }

  const filteredPayload = {
    ...payload,
    Annotations: filteredAnnotations,
  }

  yield put(actions.addClassificationAnnotations.request(filteredPayload))
}

function* onAddClassificationAnnotationsSuccess() {
  yield put(actions.closeClassificationAnnotationsTimeline())
  yield put(notificationActions.onAddInfoNotification({ message: 'Classification annotations added successfully.' }))
}

function* onAddClassificationAnnotationsFailed() {
  yield put(notificationActions.onAddErrorNotification({ message: 'Failed to create classification annotations.' }))
}

function* resetState() {
  yield put(actions.resetState())
}

function* addClassificationAnnotations() {
  yield all([
    takeLatest(actions.preprocessAddClassificationAnnotations, onPreprocessAddClassificationAnnotations),
    takeLatest(actions.addClassificationAnnotations.success, onAddClassificationAnnotationsSuccess),
    takeLatest(actions.addClassificationAnnotations.failed, onAddClassificationAnnotationsFailed),
    takeLatest(rawContentActions.resetContentState, resetState),
  ])
}

export default addClassificationAnnotations
